import { UOMContract } from 'models'
import useNewUOMForm from '../hooks/useNewUOMForm'
import { FormProvider } from 'react-hook-form'
import useUnsavedWarning from 'hooks/useUnsavedWarning/useUnsavedWarning'
import { Box, Grid } from '@mui/material'
import NewUOMFormContainer from './NewUOMFormContainer'
import { TOption } from 'components/OWForm/OWSelect'
import { Dictionary } from 'utilities/typeUtility/typeUtility'
import FormWithActionButtons from 'components/FormWithActionButtons/FormWithActionButtons'
interface NewUOMFormProps {
    uom: UOMContract
    onSave: (uom: UOMContract) => void
    onCancel: () => void
    submitting: boolean
    duplcatedUOMNames: string[]
    duplcatedUOMSymbols: Dictionary<string[]>
    uomClasses: TOption[]
    uoms: UOMContract[]
}

function NewUOMForm(props: NewUOMFormProps) {
    const {
        uom,
        onSave,
        onCancel,
        submitting,
        duplcatedUOMNames,
        duplcatedUOMSymbols,
        uomClasses,
        uoms,
    } = props

    const form = useNewUOMForm(uom, duplcatedUOMNames, duplcatedUOMSymbols)
    const {
        formState: { isDirty, isSubmitting },
        handleSubmit,
    } = form

    const [Prompt] = useUnsavedWarning(isDirty && !isSubmitting)

    return (
        <FormProvider {...form}>
            {Prompt}
            <Box component={'form'} onSubmit={handleSubmit(onSave)}>
                <FormWithActionButtons
                    onSave={() => {}}
                    onDiscard={onCancel}
                    disabled={submitting}
                    saveDisabled={!isDirty}
                    isSubmitType
                >
                    <Grid container>
                        <Grid item xs={12} md={6} lg={5}>
                            <NewUOMFormContainer
                                disabled={submitting}
                                uomClasses={uomClasses}
                                uoms={uoms}
                            />
                        </Grid>
                    </Grid>
                </FormWithActionButtons>
            </Box>
        </FormProvider>
    )
}
export default NewUOMForm
